import * as types from '../../types/reports/reportsTypes';
import { 
  getDepartmentWisePendingReport as getDepartmentWisePendingReportApi, 
  getDepartmentWiseProductionReport as getDepartmentWiseProductionReportApi 
} from '../../../api/reports/reportsApi';

export const getDepartmentWisePendingReportAction = (filters = {}) => async (dispatch) => {
  dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_REPORT_REQUEST });
  try {
    const data = await getDepartmentWisePendingReportApi(filters);
    dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_REPORT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch department-wise pending report';
    dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_REPORT_FAILURE, payload: errorMessage });
  }
};

// Export the old function name for backward compatibility
export const getDepartmentWisePendingReport = getDepartmentWisePendingReportAction;

export const getDepartmentWiseProductionReportAction = (filters = {}) => async (dispatch) => {
  dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_REQUEST });
  try {
    const data = await getDepartmentWiseProductionReportApi(filters);
    dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch department-wise production report';
    dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_FAILURE, payload: errorMessage });
  }
};

// Export the old function name for backward compatibility
export const getDepartmentWiseProductionReport = getDepartmentWiseProductionReportAction; 